<template>
  <b-badge
    v-if="tag"
    ref="badge--tag"
    pill
    :variant="`neutral-${tagVariant}`"
    :class="`${tagClass} text-${tagVariant} text__${tagClass} rounded-0`"
  >
    <div ref="tag">
      {{ tagName }}
    </div>
  </b-badge>
</template>

<script>
export default {
  name: 'BaseTag',

  props: {
    tag: {
      type: String,
      default: ''
    }
  },

  computed: {
    tagVariant() {
      if (this.tag === this.$constants.TAG.LU_OWNER) {
        return 'dark';
      }

      if (this.tag === this.$constants.TAG.LU_INSTRUCTOR) {
        return 'dark';
      }

      if (this.tag === this.$constants.TAG.LU_ASSESSOR) {
        return 'dark';
      }

      if (this.tag === this.$constants.TAG.ADDED) {
        return 'primary';
      }

      return '';
    },

    tagClass() {
      let tagClass = 'tag__status';

      if (this.tag === this.$constants.TAG.LU_OWNER) {
        tagClass += ' tag--owner';
      }

      if (this.tag === this.$constants.TAG.LU_INSTRUCTOR) {
        tagClass += ' tag--instructor';
      }

      if (this.tag === this.$constants.TAG.LU_ASSESSOR) {
        tagClass += ' tag--assessor';
      }

      if (this.tag === this.$constants.TAG.ADDED) {
        tagClass += ' tag--added';
      }

      return tagClass;
    },

    tagName() {
      let tagName = '';

      if (this.tag === this.$constants.TAG.LU_OWNER) {
        tagName = 'owner';
      }

      if (this.tag === this.$constants.TAG.LU_INSTRUCTOR) {
        tagName = 'instructor';
      }

      if (this.tag === this.$constants.TAG.LU_ASSESSOR) {
        tagName = 'assessor';
      }

      if (this.tag === this.$constants.TAG.ADDED) {
        tagName = 'added';
      }

      return tagName;
    }
  }
};
</script>

<style lang="scss" scoped></style>
